const csrfMetaTag = typeof document !== 'undefined' && document.head.querySelector('meta[name="csrf-token"]');
const csrfToken = csrfMetaTag !== null && csrfMetaTag.content;

export default csrfToken;
